import { CamelizedBundleVariants } from 'src/queries/__generated__/wweBundle';

type CalculatedVariant = { color: number; image: string };

export const calculateAvailableImages = (variants?: CamelizedBundleVariants) => {
    const usedLabels: number[] = [];
    const calculatedVariants: CalculatedVariant[] = [];

    if (!variants) return calculatedVariants;

    for (const variant of variants) {
        if (!variant) continue;

        const [firstAttribute] = variant.attributes || [];
        const color = firstAttribute?.valueIndex;
        const image = variant.product?.image?.url;

        if (color && image && !usedLabels.includes(color)) {
            usedLabels.push(color);
            calculatedVariants.push({ color: color, image: image });
        }
    }
    return calculatedVariants;
};
